// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Injectable } from '@angular/core';
import { HceViewParserService } from './parsers/hce-view-parser/hce-view-parser.service';
import { HceAnnotationParserService } from './parsers/hce-annotation-parser/hce-annotation-parser.service';
import { HceSvParserService } from './parsers/hce-sv-parser/hce-sv-parser.service';

@Injectable({ providedIn: 'root' })
export class HceParserService {
  constructor(
    public readonly annotation: HceAnnotationParserService,
    public readonly view: HceViewParserService,
    public readonly sv: HceSvParserService,
  ) {}
}
